import { ArrowLeft, Shield } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ImpactTransparencyPage() {
  const USER_BASE_PATH = "/";
  const navigate = useNavigate();

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();

  //   try {
  //     // setIsSubmitting(true);
  //     // Here you would typically send the data to your API
  //     console.log("Get Notified Email:", email);

  //     notify.success(
  //       "Successfully Registered",
  //       "Thank you! We'll notify you when the dashboard goes live."
  //     );
  //     // Reset form after successful submission
  //     setEmail("");
  //   } catch (error: any) {
  //     console.error("Form submission error:", error);
  //     notify.error(
  //       "Registration Failed",
  //       error?.message ?? "Unable to register your email. Please try again."
  //     );
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  return (
    <div className="min-h-screen bg-[#FFF9F0]">
      {/* Back to Home Link */}
      <div className="px-4 pt-4 sm:px-6 sm:pt-6 lg:px-8 lg:pt-8">
        <button
          onClick={() => navigate(USER_BASE_PATH)}
          className="group flex items-center gap-2 text-[#7A1E1E] transition-colors hover:text-[#5A1515]"
        >
          <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1 sm:h-5 sm:w-5" />
          <span className="text-xs font-medium sm:text-sm">Back to Home</span>
        </button>
      </div>

      {/* Main Content */}
      <div className="flex min-h-[calc(100vh-100px)] flex-col items-center justify-center px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          {/* Icon */}
          <div className="mb-6 flex justify-center sm:mb-8">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#7A1E1E] sm:h-20 sm:w-20 lg:h-24 lg:w-24">
              <Shield className="h-8 w-8 text-[#D4A017] sm:h-10 sm:w-10 lg:h-12 lg:w-12" />
            </div>
          </div>

          {/* Main Heading */}
          <h1 className="mb-3 text-3xl font-bold text-[#7A1E1E] sm:mb-4 sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl">
            Coming Soon
          </h1>

          {/* Subheading */}
          <h2 className="mb-4 text-xl font-semibold text-[#7A1E1E] sm:mb-6 sm:text-2xl lg:text-3xl">
            Impact Transparency Dashboard
          </h2>

          {/* Description */}
          <p className="mb-8 text-sm leading-relaxed text-gray-700 sm:mb-12 sm:text-base lg:text-lg xl:text-xl">
            We&apos;re building a revolutionary transparency platform that will
            showcase real-time impact metrics, fund allocation tracking, and
            comprehensive hostel performance data. Stay tuned for something
            extraordinary.
          </p>

          {/* Get Notified Section */}
          {/* <div className="mx-auto max-w-lg rounded-xl bg-white p-6 shadow-lg sm:rounded-2xl sm:p-8">
            <div className="mb-3 flex items-center justify-center gap-2 sm:mb-4 sm:gap-3">
              <Bell className="h-5 w-5 text-[#D4A017] sm:h-6 sm:w-6" />
              <h3 className="text-lg font-bold text-[#7A1E1E] sm:text-xl">
                Get Notified
              </h3>
            </div>

            <p className="mb-4 text-sm text-gray-700 sm:mb-6 sm:text-base">
              Be the first to know when the Impact Transparency Dashboard goes
              live.
            </p>

            <form
              onSubmit={handleSubmit}
              className="flex flex-col gap-3 sm:flex-row sm:items-start sm:gap-4"
            >
             
              <div className="flex-1">
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  placeholder="Enter your email address"
                  className="w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm focus:border-[#D4A017] focus:outline-none focus:ring-2 focus:ring-[#D4A017]/20"
                />
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="h-[42px] rounded-lg bg-[#D4A017] px-6 text-sm font-medium text-white transition-all hover:bg-[#B8900F] focus:outline-none focus:ring-2 focus:ring-[#D4A017]/50 disabled:cursor-not-allowed disabled:opacity-50 sm:px-8 sm:text-base"
              >
                {isSubmitting ? (
                  <>
                    <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                    Registering...
                  </>
                ) : (
                  "Notify Me"
                )}
              </button>
            </form>
          </div> */}
        </div>
      </div>
    </div>
  );
}
